import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { isConfigured } from "./lib/env";
import { getSupabase } from "./lib/supabase";

const root = createRoot(document.getElementById("root")!);

// Demo mode (fictional data, no server) only when the build sets VITE_DEMO=true. The literal comparison lets the
// bundler drop the demo code and its data from every other build.
if (import.meta.env.VITE_DEMO === "true") {
  void import("./demo/DemoRoot").then(({ DemoRoot }) =>
    root.render(
      <StrictMode>
        <DemoRoot />
      </StrictMode>,
    ),
  );
} else if (!isConfigured) {
  root.render(
    <div className="auth">
      <div className="auth-card">
        <h1>Not set up yet</h1>
        <p>This build has no Supabase address. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY, then build again (see apps/crm/README.md).</p>
      </div>
    </div>,
  );
} else {
  root.render(
    <StrictMode>
      <App client={getSupabase()} />
    </StrictMode>,
  );
}
